<template>
  <iModal
    :visible="isCreateLessonModalOpen"
    :max-width="500"
    title="Create Lesson"
    primary-action-button-label="Create"
    :primary-action-button-loading="isCreatingLesson"
    :primary-action-button-disabled="!isFormValid"
    :show-footer-divider="false"
    @close="closeModal"
    @click:primary="submitLesson"
    @click:secondary="closeModal"
  >
    <template #body>
      <iColumn>
        <iRow>
          <iTextInput
            v-model="lessonName"
            placeholder="What is the name of your lesson?"
            label="Name"
            required
            width="fill"
            @enter="submitLesson"
          />
        </iRow>
      </iColumn>
    </template>
  </iModal>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useCourseStore } from "@/stores/course-store";

export default {
  name: "CreateLesson",
  data() {
    return {
      lessonName: "",
    };
  },
  computed: {
    ...mapState(useCourseStore, [
      "isCreateLessonModalOpen",
      "isCreatingLesson",
      "courseId",
    ]),
    isFormValid() {
      return this.lessonName;
    },
  },
  methods: {
    ...mapActions(useCourseStore, ["closeCreateLessonModal", "createLesson"]),
    closeModal() {
      this.lessonName = "";
      this.closeCreateLessonModal();
    },
    submitLesson() {
      if (!this.isFormValid) {
        return;
      }
      this.createLesson(this.lessonName, this.courseId);
    },
  },
};
</script>

<style scoped lang="scss"></style>
